export default function scrollable() {
  return {
    //template: '<div></div>',
    restrict: 'A',
    link: function postLink(scope, element, attrs) {
      element.css('overflow', 'auto');
      element.css('max-height', 'calc(100vh - ' + attrs.scrollable + 'px)');

    }
  };
}
